// The workflow editor: its header and tabs, validation, publishing, versions and settings.
import { plural } from "../../../helpers";

const p = plural("en");

export default {
  loadError: "Could not load the workflow",
  loading: "Loading the workflow…",
  tabsLabel: "Workflow",
  tabs: { graph: "Graph", requirements: "Requirements", skills: "Skills", versions: "Versions", ratings: "Ratings", settings: "Settings" },
  savedDraft: "Saved the draft",
  savedWithIssues: (n: number) => p(n, { one: "Saved the draft with # issue", other: "Saved the draft with # issues" }),
  publishedV: (v: number) => `Published v${v}`,
  notPublished: "Not published",
  editingV: (v: number) => `Editing v${v}`,
  saveDraft: "Save draft",
  saved: "Saved",
  publish: "Publish",
  publishedVersion: (v: number) => `Published version ${v}`,
  validation: {
    title: "Validation",
    unsaved: "Unsaved changes",
    saveToCheck: "Save the draft to check it.",
    noIssuesAtSave: "No issues at the last save.",
    ready: "No issues. Ready to publish.",
    issues: "Validation issues",
  },
  publishDialog: {
    title: (v: number) => `Publish version ${v}`,
    lead: "A published version never changes. Task groups stay on the version they picked until their owner upgrades.",
    changelog: "Changelog",
    changelogPlaceholder: "What changed in this version",
    refused: (message: string) => `Not published: ${message}`,
  },
  settings: {
    details: "Details",
    detailsHint: "Shown in the marketplace",
    saveDetails: "Save details",
    savedDetails: "Saved the details",
    status: "Status",
    statusHelp: "Users find active workflows in the marketplace. Disabling or archiving hides it from new task groups; groups already on it keep running.",
    publishToActivate: "Publish a version to activate it.",
    delete: "Delete",
    deleteHelp: "Deletes the workflow and every version. Refused while a task group uses it.",
    deleteWorkflow: "Delete workflow",
    deleteConfirm: "Task groups pin a version; while one does, the API refuses and you can archive the workflow instead.",
  },
  versions: {
    loadError: "Could not load the versions",
    requirements: "Requirements",
    noRequirements: "No requirements.",
    version: (v: number) => `Version ${v}`,
    noChangelog: "No changelog.",
    by: (who: string) => `by ${who}`,
    nothingTitle: "Nothing published yet",
    nothingBody: "Publish the draft to create version 1. Each published version is kept, unchanged, for the task groups that use it.",
    list: "Published versions",
  },
};
